import { IScope } from 'angular';
import { FilterService2, IOrder } from '../../tn.common';
import { IDjangoApi1License } from '../../tn.common/classes/Model/Licenses';
import {
    ILicenseFilters,
    LicenseService,
} from '../../tn.licenses/license.service/license-service';

export class AccountLicenseFiltersController {
    activeFilters: ILicenseFilters = this.filterService.get();
    expirations = {
        Active: { id: 'Active', count: 0 },
        Expired: { id: 'Expired', count: 0 },
    };

    licenseTypes = {
        Desktop: { id: 'Desktop', count: 0 },
        Web: { id: 'Web', count: 0 },
        Application: { id: 'Application', count: 0 },
        Epub: { id: 'ePub', count: 0 },
        Broadcast: { id: 'Broadcast', count: 0 },
        Server: { id: 'Server', count: 0 },
        Game: { id: 'Game', count: 0 },
        Embedding: { id: 'Embedding', count: 0 },
    };
    isActive = { expiration: true, licenseType: true };
    licenses = this.licenseService.get();
    filteredLicenses = this.licenseService.getFilteredLicenses();

    static $inject = [
        'order',
        '$scope',
        'tnFontFilterServiceAccountLicenses',
        'tnLicenseService',
    ];
    constructor(
        public order: IOrder,
        protected $scope: IScope,
        protected filterService: FilterService2,
        protected licenseService: LicenseService
    ) {
        $scope.$watch(
            'vm.activeFilters',
            (newFilters: ILicenseFilters) => {
                licenseService.setFilteredLicenses(newFilters);
            },
            true
        );

        $scope.$watchCollection(
            'vm.licenses',
            (newLicenses: IDjangoApi1License[]) => {
                const licenses = this.order.licenses || newLicenses;
                this._countLicenseTypes(licenses);
                this._countExperations(licenses);
            }
        );
    }
    clearFilter(filter: string): void {
        this.filterService.reset(filter);
    }
    clearFilters(): void {
        this.filterService.resetAll();
    }
    hasFilter(name: string, value: string | number): boolean {
        return this.filterService.hasFilter(name, value);
    }
    toggleFilter(filter: string, obj:  string | number | { id: number | string; }): void {
        this.filterService.toggle(filter, obj);
    }

    _countLicenseTypes(licenses: IDjangoApi1License[]): void {
        this.licenseTypes.Application.count = licenses.filter(function (
            license
        ) {
            return license.fontRights.app && license.fontRights.app.qty;
        }).length;

        this.licenseTypes.Broadcast.count = licenses.filter(function (license) {
            return license.fontRights.broadcast;
        }).length;

        this.licenseTypes.Desktop.count = licenses.filter(function (license) {
            return license.fontRights.desktop && license.fontRights.desktop.qty;
        }).length;

        this.licenseTypes.Epub.count = licenses.filter(function (license) {
            return license.fontRights.epub && license.fontRights.epub.qty;
        }).length;

        this.licenseTypes.Server.count = licenses.filter(function (license) {
            return license.fontRights.server;
        }).length;

        this.licenseTypes.Game.count = licenses.filter((license) => {
            return license.fontRights.game;
        }).length;

        this.licenseTypes.Embedding.count = licenses.filter((license) => {
            return license.fontRights.embedding;
        }).length;

        this.licenseTypes.Web.count = licenses.filter((license) => {
            return license.fontRights.web && license.fontRights.web.qty;
        }).length;
    }

    _countExperations(licenses: IDjangoApi1License[]): void {
        this.expirations.Active.count = licenses.filter((license) => {
            return (
                (license.fontRights.desktop &&
                    license.fontRights.desktop.qty) ||
                (license.fontRights.epub && license.fontRights.epub.qty) ||
                (license.fontRights.app && license.fontRights.app.active) ||
                (license.fontRights.broadcast &&
                    license.fontRights.broadcast.active) ||
                (license.fontRights.server && license.fontRights.server.qty) ||
                (license.fontRights.game && license.fontRights.game.qty) ||
                (license.fontRights.embedding &&
                    license.fontRights.embedding.qty) ||
                (license.fontRights.web && license.fontRights.web.active)
            );
        }).length;

        this.expirations.Expired.count =
            licenses.length - this.expirations.Active.count;
    }
}
